"use client";

import OpportunitiesCardWrapper from "@/components/OpportunitiesCardWrapper";
import ImageCardWrapper from "@/components/pages/bus/cards/ImageCardWrapper.jsx";

import { 
  IconText,
  PopularLocationCard,
  MapViewModal,
} from "@/components/featured/common";

import {
  BlogCard,
  RouteDealCard,
  ContactInfoCard,
  GoogleMapCard,
} from "@/components/featured/bus";

export const componentRegistry = {
  PopularLocationCard,
  BlogCard,
  ImageCardWrapper,
  RouteDealCard,
  IconText,
  OpportunitiesCardWrapper,
  ContactInfoCard,
  GoogleMapCard,
  MapViewModal
};

export const itemPropMapping = {
  OpportunitiesCardWrapper: "stats",
  PopularLocationCard: "item",
  BlogCard: "post",
  RouteDealCard: "item",
  ImageCardWrapper: "item",
  ContactInfoCard: "items",
};
